import type { AdminV2LoginPopupSceneSlug } from '@/site-runtime/code-owned/login-popup-scenes';

const SECURE_COOKIE_PREFIX = '__Secure-';
const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_COOKIE_BASE_NAME =
  'imgenhancer.workspace_auth_return';
const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_HINT_COOKIE_BASE_NAME =
  'imgenhancer.workspace_auth_return_hint';

export const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_DOCUMENT_ATTRIBUTE =
  'data-site-runtime-workspace-auth-intent';
export const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_ENDPOINT =
  '/api/auth/workspace-return-intent';
export const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_TYPE = 'enter-workspace';
export const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_VERSION = 2 as const;
export const SITE_RUNTIME_WORKSPACE_AUTH_INTENT_MAX_AGE_SECONDS = 10 * 60;

export type SiteRuntimeWorkspaceAuthIntent = {
  boundToolId: string;
  createdAt: number;
  expiresAt: number;
  loginScene: AdminV2LoginPopupSceneSlug;
  pageId: string;
  returnPath: string;
  type: typeof SITE_RUNTIME_WORKSPACE_AUTH_INTENT_TYPE;
  version: typeof SITE_RUNTIME_WORKSPACE_AUTH_INTENT_VERSION;
};

function getCookieName(baseName: string, secure: boolean) {
  return secure ? `${SECURE_COOKIE_PREFIX}${baseName}` : baseName;
}

export function getSiteRuntimeWorkspaceAuthIntentCookieName(secure: boolean) {
  return getCookieName(
    SITE_RUNTIME_WORKSPACE_AUTH_INTENT_COOKIE_BASE_NAME,
    secure
  );
}

export function getSiteRuntimeWorkspaceAuthIntentCookieCandidates() {
  return [
    getSiteRuntimeWorkspaceAuthIntentCookieName(true),
    getSiteRuntimeWorkspaceAuthIntentCookieName(false),
  ] as const;
}

export function getSiteRuntimeWorkspaceAuthIntentHintCookieName(
  secure: boolean
) {
  return getCookieName(
    SITE_RUNTIME_WORKSPACE_AUTH_INTENT_HINT_COOKIE_BASE_NAME,
    secure
  );
}

export function getSiteRuntimeWorkspaceAuthIntentHintCookieCandidates() {
  return [
    getSiteRuntimeWorkspaceAuthIntentHintCookieName(true),
    getSiteRuntimeWorkspaceAuthIntentHintCookieName(false),
  ] as const;
}
